import { render, staticRenderFns } from "./directActionsBlock.vue?vue&type=template&id=b86bdb16&scoped=true"
import script from "./directActionsBlock.vue?vue&type=script&lang=js"
export * from "./directActionsBlock.vue?vue&type=script&lang=js"
import style0 from "./directActionsBlock.vue?vue&type=style&index=0&id=b86bdb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86bdb16",
  null
  
)

export default component.exports